import { Patch } from '@/core/models/patch.interface';
import { StoreState } from '@/core/models/store.interface';
import { Timetable } from '@/core/models/timetable.interface';
import { Module } from 'vuex';
import { TimetableService } from './timetable.service';

const service = new TimetableService();

export interface TimetableState {}

const TimetableStore: Module<TimetableState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async patchTimetable(context, payload: { contractId: number; timetableId: number; itemsToPatch: Array<Patch> }) {
         return await service.patchTimetable(payload.contractId, payload.timetableId, payload.itemsToPatch);
      },
   },
};

export default TimetableStore;
